import './App.css';
import Web from './page.jsx'
import ProjectsPage from './projects.jsx';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import TeamPage from './team.jsx';
import { ThemeProvider } from './ThemeContext';
import WhyJoin from './WhyJoin.jsx';
import ImpactPage from './ImpactPage.jsx';
import GalleryPage from './GalleryPage.jsx';
import CommunityInitiatives from './CommunityInitiatives.jsx';
import Chapters from './Chapters.jsx';
import ChapterDetail from './ChapterDetail.jsx';
import ContactPage from './ContactPage.jsx';
import ResourcesPage from './ResourcesPage.jsx';
import ProjectProposalPage from './ProjectProposalPage.jsx';
import { useEffect } from 'react';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
};

function App() {
     if (sessionStorage.redirect) {
      var redirect = sessionStorage.redirect;
      sessionStorage.removeItem('redirect');
      if (redirect && redirect !== "/" && redirect !== "/index.html") {
        window.history.replaceState(null, null, redirect);
      }
    }
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Web />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/why-join" element={<WhyJoin />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/community-initiatives" element={<CommunityInitiatives />} />
          <Route path="/chapters" element={<Chapters />} />
          <Route path="/chapters/:chapterId" element={<ChapterDetail />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/project-proposal" element={<ProjectProposalPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
